import {Button, Card, Col, Form, Input, Row} from "antd"
import {FC, PropsWithChildren, useCallback, useState} from "react"
import {formItemConfig} from '@/config/config'
import DrawContainer from '@/components/DrawContainer'
import * as api from "@/api/user"
import {successAlert} from "@/utils/utils"
import {useUserInfoContext} from '@/store/userInfo'

type PropType = FC<PropsWithChildren<{
    onCancel: () => void
}>>

const Edit: PropType = ({onCancel}) => {
    const {userInfo} = useUserInfoContext()
    const [form] = Form.useForm()
    const [ps, setPs] = useState('')

    const handleSave = useCallback(async () => {
        try {
            await form.validateFields()
            const res = await api.savePassword({
                mm: ps,
                id: userInfo.sysid
            })
            if (res.status) {
                successAlert(res.msg, onCancel)
            }
        } catch (e) {
            form.scrollToField(e.errorFields[0].name[0].toString());
        }

    }, [form, ps, userInfo, onCancel])

    // 校验密码
    const checkPassword = useCallback(async (rule, val) => {
        if (!val) {
            return Promise.reject(new Error('请输入'))
        }
        const res = await api.checkPassord({
            dlid: userInfo.sysid,
            pwd: val
        })
        if (res.status) {
            return true
        } else {
            return Promise.reject(new Error(res.msg))
        }
    }, [userInfo])

    return (
        <DrawContainer
            footer={
                <div>
                    <Button onClick={() => onCancel()}>关闭</Button>
                    <Button type="primary" className="ml-30" onClick={handleSave}>保存</Button>
                </div>
            }
        >
            <Form form={form}>
                <Card title="基础信息">
                    <Row style={{maxWidth: '700px'}}>
                        <Col span={24}>
                            <Form.Item label="原密码" name="ymm"
                                       rules={[{required: true, validator: checkPassword}]} {...formItemConfig.normal}>
                                <Input.Password placeholder="请输入"/>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="密码" name="mm"
                                       rules={[{required: true, message: '请输入'}]} {...formItemConfig.normal}>
                                <Input.Password placeholder="请输入" onChange={(e) => setPs(e.target.value)}/>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="确认密码" name="qrmm" rules={[{
                                required: true, validator(rule, value, callback) {
                                    if (!value) {
                                        callback('请输入')
                                        return
                                    }
                                    if (ps !== value) {
                                        callback('两次输入不一致！')
                                    } else {
                                        callback()
                                    }
                                },
                            }]} {...formItemConfig.normal}>
                                <Input.Password placeholder="请输入"/>
                            </Form.Item>
                        </Col>

                    </Row>
                </Card>
            </Form>
        </DrawContainer>
    )
}

export default Edit
